// This file is auto-generated by @hey-api/openapi-ts

/**
 * [Relational Tariff Core] Ticket type.
 */
export const RelationalTariffCoreTicketTypesEnum = {
    COUPON: 'COUPON',
    PUBLIC_TRANSPORT: 'PUBLIC_TRANSPORT',
    ALL_NETWORK: 'ALL_NETWORK'
} as const;

/**
 * [Relational Tariff Core] Ticket type.
 */
export type RelationalTariffCoreTicketTypesEnum = typeof RelationalTariffCoreTicketTypesEnum[keyof typeof RelationalTariffCoreTicketTypesEnum];
